const DISPLAY_NAME_KEY = 'userDisplayName';
const SPEAKER_SECRET_KEY = 'streamrtv-speakerSecret';
const USER_ROLE_KEY = 'streamrtv-userRole';
const ONE_TO_ONE_STREAM_URL_KEY = 'streamrtv-oneToOneStreamUrl';
const ACCEPTED_PARTICIPANT_TYPE_KEY = 'streamrtv-acceptedParticipantType';
const BROADCASTING_ENABLED_KEY = 'streamrtv-broadcastingEnabled';
const HOST_ACCEPTED_USERS_KEY = 'streamrtv-hostAcceptedUsers';
const HOST_WAS_LIVE_KEY = 'streamrtv-hostWasLive';
function uint8ArrayToHex(arr) {
    return Array.from(arr)
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('');
}
function hexToUint8Array(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
        bytes[i / 2] = Number.parseInt(hex.substring(i, i + 2), 16);
    }
    return bytes;
}
export class UserStore {
    getDisplayName() {
        try {
            return localStorage.getItem(DISPLAY_NAME_KEY) ?? undefined;
        }
        catch {
            return undefined;
        }
    }
    setDisplayName(name) {
        try {
            localStorage.setItem(DISPLAY_NAME_KEY, name);
        }
        catch {
            // localStorage may be unavailable in some environments
        }
    }
    getSpeakerSecret(streamId) {
        try {
            const hex = localStorage.getItem(`${SPEAKER_SECRET_KEY}-${streamId}`);
            return hex ? hexToUint8Array(hex) : undefined;
        }
        catch {
            return undefined;
        }
    }
    setSpeakerSecret(streamId, secret) {
        try {
            localStorage.setItem(`${SPEAKER_SECRET_KEY}-${streamId}`, uint8ArrayToHex(secret));
        }
        catch {
            // localStorage may be unavailable
        }
    }
    clearSpeakerSecret(streamId) {
        try {
            localStorage.removeItem(`${SPEAKER_SECRET_KEY}-${streamId}`);
        }
        catch {
            // localStorage may be unavailable
        }
    }
    getUserRole(hostUserId) {
        try {
            const val = localStorage.getItem(`${USER_ROLE_KEY}-${hostUserId}`);
            return val !== null ? Number(val) : undefined;
        }
        catch {
            return undefined;
        }
    }
    setUserRole(hostUserId, role) {
        try {
            localStorage.setItem(`${USER_ROLE_KEY}-${hostUserId}`, String(role));
        }
        catch {
            // localStorage may be unavailable
        }
    }
    clearUserRole(hostUserId) {
        try {
            localStorage.removeItem(`${USER_ROLE_KEY}-${hostUserId}`);
        }
        catch {
            // localStorage may be unavailable
        }
    }
    getOneToOneStreamUrl(hostUserId) {
        try {
            return (localStorage.getItem(`${ONE_TO_ONE_STREAM_URL_KEY}-${hostUserId}`) ?? undefined);
        }
        catch {
            return undefined;
        }
    }
    setOneToOneStreamUrl(hostUserId, url) {
        try {
            localStorage.setItem(`${ONE_TO_ONE_STREAM_URL_KEY}-${hostUserId}`, url);
        }
        catch {
            // localStorage may be unavailable
        }
    }
    clearOneToOneStreamUrl(hostUserId) {
        try {
            localStorage.removeItem(`${ONE_TO_ONE_STREAM_URL_KEY}-${hostUserId}`);
        }
        catch {
            // localStorage may be unavailable
        }
    }
    /**
     * Host-side roster of accepted participants (userId → role), keyed by
     * streamId. Lets a reloaded host re-accept its guests so the session
     * recovers without any guest action.
     */
    getHostAcceptedUsers(streamId) {
        try {
            const val = localStorage.getItem(`${HOST_ACCEPTED_USERS_KEY}-${streamId}`);
            return val ? JSON.parse(val) : {};
        }
        catch {
            return {};
        }
    }
    setHostAcceptedUser(streamId, userId, role) {
        try {
            const users = this.getHostAcceptedUsers(streamId);
            users[userId] = role;
            localStorage.setItem(`${HOST_ACCEPTED_USERS_KEY}-${streamId}`, JSON.stringify(users));
        }
        catch {
            // localStorage may be unavailable
        }
    }
    removeHostAcceptedUser(streamId, userId) {
        try {
            const users = this.getHostAcceptedUsers(streamId);
            delete users[userId];
            localStorage.setItem(`${HOST_ACCEPTED_USERS_KEY}-${streamId}`, JSON.stringify(users));
        }
        catch {
            // localStorage may be unavailable
        }
    }
    getHostWasLive(streamId) {
        try {
            return (localStorage.getItem(`${HOST_WAS_LIVE_KEY}-${streamId}`) === '1');
        }
        catch {
            return false;
        }
    }
    setHostWasLive(streamId, live) {
        try {
            if (live) {
                localStorage.setItem(`${HOST_WAS_LIVE_KEY}-${streamId}`, '1');
            }
            else {
                localStorage.removeItem(`${HOST_WAS_LIVE_KEY}-${streamId}`);
            }
        }
        catch {
            // localStorage may be unavailable
        }
    }
    getAcceptedParticipantType(streamId) {
        try {
            const val = localStorage.getItem(`${ACCEPTED_PARTICIPANT_TYPE_KEY}-${streamId}`);
            return val !== null ? Number(val) : undefined;
        }
        catch {
            return undefined;
        }
    }
    setAcceptedParticipantType(streamId, type) {
        try {
            localStorage.setItem(`${ACCEPTED_PARTICIPANT_TYPE_KEY}-${streamId}`, String(type));
        }
        catch {
            // localStorage may be unavailable
        }
    }
    getBroadcastingEnabled(streamId) {
        try {
            const val = localStorage.getItem(`${BROADCASTING_ENABLED_KEY}-${streamId}`);
            return val !== null ? val === 'true' : undefined;
        }
        catch {
            return undefined;
        }
    }
    setBroadcastingEnabled(streamId, enabled) {
        try {
            localStorage.setItem(`${BROADCASTING_ENABLED_KEY}-${streamId}`, String(enabled));
        }
        catch {
            // localStorage may be unavailable
        }
    }
}
